<template>
  <div class="flex flex-col items-start md:items-end">
    <ButtonComponent
      @click.prevent="clicked"
      label="Delete"
      variant="secondary"
      :disabled="disabled"
    >
      <template #icon>
        <DeleteIcon
          :isDecorative="true"
          :title="null" />
      </template>
    </ButtonComponent>
  </div>
</template>

<script setup lang="ts">
import { SubmissionFileType } from '@/types'
import DeleteIcon from '../../components/ui-components/icons/DeleteIcon.vue'
import ButtonComponent from '../ui-components/ButtonComponent.vue'

const emits = defineEmits(['delete'])

defineProps({
  fileType: { required: true, type: String as () => SubmissionFileType },
  disabled: { type: Boolean, default: false },
})

const clicked = async () => {
  emits('delete')
}
</script>
